import ReactOnRails from 'react-on-rails';

import WebsiteWidgetV3 from '../components/WebsiteWidgetV3';
import WebsiteWidgetV2 from '../components/WebsiteWidgetV2';

/* add mixpanel script */
import './lib/Mixpanel.js.erb';

/* add google recaptcha v3 */
import './lib/reCAPTCHA-v3.js.erb';

ReactOnRails.register({ WebsiteWidgetV2, WebsiteWidgetV3 });
